// Colors
const colors = {
  black: '#000000',
  blackTwo: '#323232',
  white: '#f4f4f4',
  green: '#5affb4',
  grayTone1: '#252525',
  grayTone2: '#606060',
  grayTone3: '#aaaaaa',
  grayTone4: '#cccccc',
  gray: '#dddddd',
  red: '#f5004b'
}

// Color assignments
colors.highlight = colors.green

const fontFamilies = {
  aeonik: 'Aeonik',
  saol: 'SaolDisplay'
}

const sizes = {
  mobile: 320,
  tablet: 720,
  desktop: 1024,
  lDesktop: 1280,
  xlDesktop: 1440,
}

const TEXT_DOMAIN = 'sponda'

export {
  colors,
  sizes,
  fontFamilies,
  TEXT_DOMAIN
}

